@if (priceLevelVisible()) {
  <div
    (click)="toggleDropdown()"
    [title]="access.getTitle('change_results_price_level')"
    [class]="'flex items-center gap-1 justify-between ' + (priceLevelDisabled() ? 'cursor-not-allowed text-fg-disabled' : 'cursor-pointer')"
    id="results_table_price_dropdown"
  >
    {{resultsStore.currentPriceLevel()?.name || ''}}
    <app-icons icon="chevron-right" class="transition-transform duration-300" [class.rotate-90]="isPriceDropdownOpen()"></app-icons>
  </div>

  @if (isPriceDropdownOpen()) {
    <div class="absolute z-10 bg-white rounded-base shadow-lg w-52 mt-1 scale-95 rounded-lg max-h-1/2 overflow-y-auto">
      <ul class="p-2 text-sm text-body font-medium">
        @for (option of appStore.price_levels(); track $index) {
          <li [title]="option.name">
            <a (click)="setPriceLevel(option); $event.preventDefault()"
               class="inline-flex items-center w-full p-2 hover:bg-gray-100 hover:text-brand-strong rounded cursor-pointer min-w-0">
              <span class="truncate">{{option.name}}</span>
            </a>
          </li>
        }
      </ul>
    </div>
  }
} @else {
  <div id="results_table_price_dropdown">
    {{resultsStore.currentPriceLevel()?.name || ''}}
  </div>
}

